import { STRING } from 'resources'

import { getSubscriptionData } from './api'

const STATUS_MAP = {
  subscription_active: {
    eventPayload: 'subscriber',
    statusLabel: STRING.protect.subscriptionStatus.subscribed,
    daysRemainingLabel: STRING.protect.subscriptionStatus.daysRemaining.renewsIn,
    linkLabel: null,
  },
  subscription_expired: {
    eventPayload: 'subscription expired',
    statusLabel: STRING.protect.subscriptionStatus.subscriptionExpired,
    daysRemainingLabel: STRING.protect.subscriptionStatus.daysRemaining.endedOn,
    linkLabel: STRING.protect.subscriptionStatus.subscribeLink,
  },
  trial_active: {
    eventPayload: 'trial',
    statusLabel: STRING.protect.subscriptionStatus.trial,
    daysRemainingLabel: STRING.protect.subscriptionStatus.daysRemaining.endsIn,
    linkLabel: STRING.protect.subscriptionStatus.subscribeLink,
  },
  trial_expired: {
    eventPayload: 'trial expired',
    statusLabel: STRING.protect.subscriptionStatus.trialExpired,
    daysRemainingLabel: STRING.protect.subscriptionStatus.daysRemaining.endedOn,
    linkLabel: STRING.protect.subscriptionStatus.subscribeLink,
  },
}

const createSubscriptionData = (subscriptionData) => ({
  status: subscriptionData?.status ?? null,
  link: subscriptionData?.link ?? null,
  daysRemaining: subscriptionData?.daysRemaining ?? null,
})

export const getReklaimProtectSubscriptionData = async (primaryEmail) => {
  let subscriptionData
  try {
    subscriptionData = await getSubscriptionData(primaryEmail)
  } catch (error) {
    subscriptionData = null
  }
  subscriptionData = createSubscriptionData(subscriptionData)

  const { status, link, daysRemaining } = subscriptionData
  const result = STATUS_MAP[status] || {
    statusLabel: STRING.protect.subscriptionStatus.undetermined,
    daysRemainingLabel: STRING.protect.subscriptionStatus.daysRemaining.endsIn,
    daysRemaining: STRING.protect.subscriptionStatus.daysRemaining.unknown,
    linkLabel: null,
    link: null,
  }

  return {
    ...result,
    daysRemaining: daysRemaining || STRING.protect.subscriptionStatus.daysRemaining.unknown,
    link: link || null,
  }
}
